import React from "react";

/**
 * ThemedLoader — branded loader matching the indigo → purple → pink palette.
 *
 * Variants:
 *   - "page"       : centers in the page with min-height 60vh (default)
 *   - "fullscreen" : fixed overlay covering the viewport with a blurred backdrop
 *   - "inline"     : sits inline with surrounding content, no min-height
 *
 * Sizes:
 *   - "sm" | "md" (default) | "lg"
 */
const ThemedLoader = ({
  variant = "page",
  size = "md",
  label = "Loading",
  showDots = true,
  className = "",
  style,
}) => {
  const wrapClass =
    variant === "fullscreen"
      ? "themed-loader-wrap fullscreen"
      : variant === "inline"
      ? "themed-loader-wrap"
      : "themed-loader-wrap full-page";

  const orbitClass = `themed-loader-orbit ${
    size === "sm" ? "sm" : size === "lg" ? "lg" : ""
  }`.trim();

  return (
    <div className={`${wrapClass} ${className}`.trim()} style={style}>
      <div className={orbitClass}>
        <div className="themed-loader-core" />
      </div>
      {label && (
        <div className="themed-loader-label">
          <span>{label}</span>
          {showDots && <span className="dots" />}
        </div>
      )}
    </div>
  );
};

export default ThemedLoader;
